import { createContext, useCallback, useContext, useState } from "react";
import NotificationApi from "../api/Admin/Notification";
import { Notification } from "../api/types";

interface NotificationsContextType {
  unreadNotificationsCount: number;
  notifications: Notification[];
  setNotifications: React.Dispatch<React.SetStateAction<Notification[]>>;
  getNotificationsForUser: () => Promise<void>;
  isNotificationDataLoading: boolean;
}

const NotificationContext = createContext<NotificationsContextType | null>(null);

interface NotificationsContextProviderProps {
  children: React.ReactNode;
}

export const NotificationContextProvider = ({ children }: NotificationsContextProviderProps) => {
  const [notifications, setNotifications] = useState<Notification[]>([]);
  const [isNotificationDataLoading, setIsNotificationDataLoading] = useState<boolean>(false);

  const unreadNotificationsCount = notifications?.filter(
    (notification) => !notification?.isAcknowledged,
  ).length;

  const getNotificationsForUser = useCallback(async () => {
    setIsNotificationDataLoading(true);

    const response = await NotificationApi.getMyNotifications(-1);

    setIsNotificationDataLoading(false);

    const adaptedResponse = response?.map((notification: Notification) => {
      return { ...notification };
    });

    setNotifications(adaptedResponse);
  }, []);

  return (
    <NotificationContext.Provider
      value={{
        unreadNotificationsCount,
        notifications,
        setNotifications,
        getNotificationsForUser,
        isNotificationDataLoading,
      }}>
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = (): NotificationsContextType => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error("useNotification must be used within a NotificationContextProvider");
  }
  return context;
};

export default NotificationContext; //remove eventually & replace with useNotification hook
